export default "__VITE_ASSET__DSw71QRe__"